import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiDependencyProviderService } from '@web/common';
import { NewsletterSubscribeRequest } from '../requests/newsletter-subscribe.request';
import { blank } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class NewsletterApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public subscribe(request: NewsletterSubscribeRequest): Observable<void> {
    const path = 'newsletter/subscribe';
    const url = this.provider.httpUrlFactory.simple(this.hostUrl(), path);
    const body = this.provider.httpHelper.requestToBody(
      request,
      NewsletterSubscribeRequest,
    );
    const context = this.provider.httpContextBuilder
      .skipByRefreshTokenInterceptor()
      .skipByHttpErrorInterceptor()
      .skipByAuthTokenInterceptor()
      .build();

    return this.provider.http.post(url, body, { context }).pipe(blank());
  }

  protected hostUrl(): string {
    return this.provider.environment.ApiHostUrl.SSO;
  }
}
